// src/components/contact/ContactHero.jsx
import React from 'react';
import { motion } from 'framer-motion';

const ContactHero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.5,
        staggerChildren: 0.3,
      },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section className="bg-[url('https://images.unsplash.com/photo-1635776062127-d379bfcba9f8')] bg-cover bg-center py-32 md:py-48 text-white relative flex items-center justify-center">
      <div className="absolute inset-0 bg-black opacity-60"></div>
      <div className="container mx-auto px-4 relative z-10 text-center">
        <motion.div
          className="max-w-xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1
            className="text-4xl font-bold font-heading mb-6 md:text-5xl lg:text-6xl"
            variants={textVariants}
          >
            Reach Out to Us
          </motion.h1>
          <motion.p
            className="text-lg mb-8 md:text-xl"
            variants={textVariants}
            transition={{ delay: 0.6 }}
          >
            We're here to answer your questions and provide support. Get in touch!
          </motion.p>
          {/* You could add a brief introductory message or a call to action here */}
        </motion.div>
      </div>
    </section>
  );
};

export default ContactHero;